<template>
  <UiCheckbox
    :label="t('label')"
    :isChecked="!!checked"
    @inputValue="updateIsAllowedWithChild"
  />
</template>

<script setup lang="ts">
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { useI18n } from '@experience/i18n';
  import ru from '../i18n/ru.json';

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  interface Props {
    checked: boolean | null;
  }

  defineProps<Props>();

  const isAllowedWithChild = defineModel();

  const updateIsAllowedWithChild = (isAllowed: boolean) => {
    isAllowedWithChild.value = isAllowed;
  };
</script>
